import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"

import { Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import CreateBloc from './Blocs/CreateBloc'

class CreateView extends Component {
    createBloc = new CreateBloc()
    
    source

    constructor(props) {
        super(props)
        this.state = {
            menuList: [],
            dataForm: {},
            isLoading: 0 
        }
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: values,
            confirm: true
        })
    }

    loadMenu = async () => {
        const query = {

        }
        await this.createBloc.fetchMenu(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadMenu()
    }

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }


    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.setTokenAPI()

        this.createBloc.menuChannel.subscribe((result) => {
            console.log('cek result', result)
            switch (result.status) {
                case apiResponse.INITIAL: 
                    this.setState({ isLoading: 25 })
                    break
                case apiResponse.LOADING:
                    this.setState({ isLoading: 50 })
                    break
                case apiResponse.COMPLETED:
                    this.setState({ isLoading: 100 })
                    setTimeout(() => {
                        this.setState({ menuList: result.data.response })
                    }, 800);
                    break
                case apiResponse.ERROR:
                    this.setState({ isLoading: 100 })
                    break
                default:
                    break
            }
        })

        
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.createBloc.createChannel.unsubscribe()
        this.createBloc.menuChannel.unsubscribe()
    }

    render() {
        let count = -1;
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <CardTitle>Buat Hak Akses</CardTitle>
                            <hr/>
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >
                                <Row mb="3">
                                    <Col md="6">
                                        <AvGroup>
                                            <Label htmlFor="fieldAccessCode">Kode Akses</Label>
                                            <AvField
                                                name="access_code"
                                                placeholder="Kode Akses..."
                                                type="text"
                                                className="form-control"
                                                id="fieldAccessCode"
                                            />
                                        </AvGroup>
                                    </Col>

                                    <Col md="6">
                                        <AvGroup>
                                            <Label htmlFor="fieldAccessName">Name Akses</Label>
                                            <AvField
                                                name="access_name"
                                                placeholder="Nama Akses..."
                                                type="text"
                                                className="form-control"
                                                id="fieldAccessName"
                                            />
                                        </AvGroup>
                                    </Col>

                                    {/* Menu Disini */}
                                    { this.state.menuList?.result ?
                                        <Col md="12">
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <th><AvInput type="checkbox" name="selectAll" /></th>
                                                        <th>Nama Menu</th>
                                                        <th>Read</th>
                                                        <th>Create</th>
                                                        <th>Update</th>
                                                        <th>Delete</th>
                                                        <th>Approve</th>
                                                        <th>Print</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.menuList?.result.map((value, index) => {
                                                        const isHaveChild = (value.childs.length > 0);
                                                        const childs = isHaveChild && value.childs
                                                        count++;
                                                        return (
                                                            <Fragment key={index}>
                                                                <tr>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isChecked[${count}]`} />
                                                                    </td>
                                                                    <td>
                                                                        <Label>{value.menu_name}</Label>
                                                                        <AvField name={`menuId[${count}]`} value={value.menu_id} type="hidden" />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isRead[${count}]`} />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isCreate[${count}]`} />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isUpdate[${count}]`} />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isDelete[${count}]`} />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isApprove[${count}]`} />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isPrint[${count}]`} />
                                                                    </td>
                                                                </tr>
                                                                { isHaveChild &&
                                                                    childs.map(( child, i ) => {
                                                                        count++;
                                                                        return (
                                                                            <tr key={i}>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isChecked[${count}]`} />
                                                                                </td>
                                                                                <td>
                                                                                    <Label style={{ marginLeft: '30px' }}>{child.menu_name}</Label>
                                                                                    <AvField name={`menuId[${count}]`} value={child.menu_id} type="hidden" />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isRead[${count}]`} />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isCreate[${count}]`} />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isUpdate[${count}]`} />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isDelete[${count}]`} />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isApprove[${count}]`} />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isPrint[${count}]`} />
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </Fragment>
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>

                                            <Button type="submit" style={{ float: 'right', marginTop: '12px' }} color="primary">Submit</Button>
                                        </Col>
                                        :
                                        <Col md="12" style={{ marginTop: 12 }}>
                                            <Progress value={this.state.isLoading} />
                                        </Col>
                                    }

                                </Row>
                            </AvForm>
                        </CardBody>
                    </Card>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/setting/accesses.html'/>
                : null }
            </Fragment>
        )
    }
}

export default CreateView